import React, { useState } from 'react';
import { Button, Drawer, FormControl, FormHelperText, IconButton, InputLabel, LinearProgress, MenuItem, Select } from '@mui/material';
import AssistantIcon from '@mui/icons-material/Assistant';
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'
import CloseIcon from '@mui/icons-material/Close';
import APIInvoke from '../../utils/APIInvoke';
import { fromISOToUTCFormat } from '../../utils/DateUtilsUTC';
import toast from 'react-hot-toast';


const CompareDocument = ({ open, onClose, project, collection, documentId, revisions = [], firstRevision, secondRevision }) => {

    const [state, setState] = useState({
        loadingAssistant: false,
        firstRevision: firstRevision,
        secondRevision: secondRevision,
        agentResponse: undefined,
        /*        
                risks: [],
                risk: {
                    level: "",
                    description: ""
                },
                resume: "",
                analytic: "",
                checklist: [],
          */
    })

    const compareDocuments = async (e) => {
        try {
            setState({
                ...state,
                loadingAssistant: true
            })
            const request = {
                documentId: documentId,
                currentRevision: state.firstRevision.revision,
                previousRevision: state.secondRevision.revision
            }

            const response = await (await APIInvoke.invokePOST(`/projects/${project}/ia/collections/${collection}/documents/compare`, request)).json()
            setState({
                ...state,
                agentResponse: response.body
            })
        } catch (error) {
            toast.error(error.message)
            setState({
                ...state,
                loadingAssistant: false
            })
        } 

    }

    const getRiskColor = (risk) => {
        if (risk === "low") return "text-green-500"
        if (risk === "medium") return "text-yellow-500"
        if (risk === "high") return "text-red-500"
        return "text-gray-500"
    }

    const updateRevision = (e) => {
        const revision = revisions.find(rev => rev.revision === e.target.value)
        setState({
            ...state,
            [e.target.name]: revision
        })
    }

    return (
        <Drawer
            anchor={'right'}
            className=" !border !border-dark-600"
            open={open}
            onClose={onClose}
        >

            <div className="flex flex-col justify-between w-[800px] h-screen overflow-hidden ">

                <div className="flex flex-row justify-between items-center bg-dark-900 h-[62px] p-2">
                    <p className='flex flex-row gap-2 items-center text-white text-lg font-bold  px-2 '><AssistantIcon /> Assistant</p>
                    <IconButton onClick={() => onClose(false)} className="!text-green-500">
                        <CloseIcon className="text-white" />
                    </IconButton>
                </div>

                <div className="grid grid-cols-2 gap-4 bg-gray-200 p-8 border-b border-gray-500">



                    <FormControl>
                        <InputLabel id="firstRevisionLabel" >Base comparison version</InputLabel>
                        <Select
                            size="small"
                            className=""
                            name="firstRevision"
                            placeholder="Select a revision"
                            value={state.firstRevision?.revision}
                            onChange={updateRevision}
                        >
                            {revisions && revisions?.map(rev => (
                                <MenuItem value={rev.revision}>Revision {rev.revision} - {fromISOToUTCFormat(rev.createAt, 'dd/MM/yyyy HH:mm:ss')}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl>
                        <InputLabel id="secondRevisionLabel" >Comparate to</InputLabel>
                        <Select
                            size="small"
                            className=""
                            name="secondRevision"
                            placeholder="Select a revision"
                            defaultValue={state.secondRevision?.revision - 1}
                            value={state.secondRevision?.revision}
                            onChange={updateRevision}
                        >
                            {revisions && revisions?.map(rev => (
                                <MenuItem disabled={rev.revision === state.firstRevision?.revision} value={rev.revision}>Revision {rev.revision} - {fromISOToUTCFormat(rev.createAt, 'dd/MM/yyyy HH:mm:ss')}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>


                </div>

                <div className="flex-1 p-8 bg-gray-100 markdown overflow-auto">
                    {console.log("state.agentResponse", state.agentResponse)}
                    {state.agentResponse && (
                        <>
                            <div>
                                <p className="text-2xl font-bold !pb-0"><span className={`capitalize ${getRiskColor(state.agentResponse.risk.level)}`}>{state.agentResponse.risk.level} risk</span></p>
                                <p className="">{state.agentResponse.risk.description}</p>
                            </div>
                            <h2>Resumen</h2>
                            <ReactMarkdown children={state.agentResponse.resumen} remarkPlugins={[remarkGfm]} />
                            <h2>Analytic</h2>
                            <ReactMarkdown children={state.agentResponse.analytic} remarkPlugins={[remarkGfm]} />
                            <h2>Risks</h2>
                            <ul>
                                {state.agentResponse.risks.map((risk, index) => (
                                    <li key={index}>
                                        <p><span className="font-bold">{risk.level}</span>: <span className="inline-block"><ReactMarkdown children={risk.description} remarkPlugins={[remarkGfm]} /></span></p>
                                    </li>
                                ))}
                            </ul>
                            <h2>Recommendations</h2>
                            <ReactMarkdown children={state.agentResponse.checklist.map(x => "\n * " + x).join('')} remarkPlugins={[remarkGfm]} />
                        </>
                    )}
                </div>

                <div className="">
                    {state.loadingAssistant && <LinearProgress size="sm" className="" />}
                    <div className="p-4">
                        <Button type="button" onClick={(e) => compareDocuments(e)} variant="contained" className="w-full">Consult</Button>
                    </div>
                </div>
            </div>
        </Drawer>
    );
};

export default CompareDocument;